import React from "react";
import "./styles.css";
import { RootState } from "../../../../../store";
import {
  selectUserInfo,
  selectUserPending,
  selectUserToken,
} from "../../../../../store/selectors";
import { connect } from "react-redux";
import { useCookies } from "react-cookie";
import { ReactComponent as BurgerIcon } from "../../../../../assets/icons/burger.svg";
import { Button } from "../../../Button";
import {useLocation, useNavigate} from "react-router-dom";
import {isLanding} from "../../../../../constants/common";

const normalizeAuthToken = (value) => {
  const token = String(value || "").trim();
  return token && token !== "undefined" && token !== "null" ? token : "";
};

const _UserBar = ({ pending, token, user, setSideMenuIsOpen }) => {
  const [cookies] = useCookies();
  const userToken = normalizeAuthToken(cookies.userToken);
  const storeToken = normalizeAuthToken(token);
  const hasToken = Boolean(userToken || storeToken);
  const isAuth = hasToken && Boolean(user);
  const navigate = useNavigate();
  const isAuthPage = useLocation()?.pathname.includes("/signin");
  const burgerStrokeColor = isLanding ? "#fff" : "#818c99";

  if (pending && hasToken && !user) {
    return null;
  }

  if (!isAuth && !isAuthPage) {
    return <Button className="userbar_login" text="войти" onClick={() => navigate("/signin")} />;
  }

  if (!isAuth && isAuthPage) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        aria-label="Открыть меню профиля"
        className="userbar_logout-button"
        onClick={() => setSideMenuIsOpen(true)}
      >
        {/*<DefaultAvatar*/}
        {/*  name={userData.user.name}*/}
        {/*  color={userData.user.avatarColor}*/}
        {/*  width={36}*/}
        {/*  height={36}*/}
        {/*/>*/}
        <BurgerIcon width="36px" height="36px" stroke={burgerStrokeColor} />
      </button>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  pending: selectUserPending(state),
  token: selectUserToken(state),
  user: selectUserInfo(state),
});

export const UserBar = connect(mapStateToProps, null)(_UserBar);
